var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 718.9 124",
    style: {
      enableBackground: "new 0 0 718.9 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#272951;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.5,51c4.5,0,8.7,1,12.5,3.1c3.8,2,7,5.1,9.5,9.2l15.9-9.3c-3.3-6.6-8.2-11.7-14.8-15.2 c-6.6-3.5-14.2-5.3-22.9-5.3c-9.3,0-17.5,1.9-24.7,5.8c-7.2,3.9-12.9,9.2-17,16.1c-4.1,6.8-6.1,14.6-6.1,23.3 c0,8.7,2,16.5,6.1,23.4c4.1,6.9,9.8,12.3,17,16.1c7.3,3.9,15.5,5.8,24.7,5.8c8.6,0,16.2-1.8,22.8-5.4c6.6-3.6,11.6-8.7,15-15.3 L197.5,94c-2.5,4.1-5.7,7.1-9.5,9.2c-3.8,2-8,3.1-12.5,3.1c-7.8,0-14.3-2.5-19.3-7.5c-5-5-7.5-11.7-7.5-20.1 c0-8.4,2.5-15.1,7.6-20.1C161.3,53.5,167.7,51,175.5,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,51c4.5,0,8.7,1,12.5,3.1c3.8,2,7,5.1,9.5,9.2l15.9-9.3c-3.3-6.6-8.2-11.7-14.8-15.2 c-6.6-3.5-14.2-5.3-22.9-5.3c-9.3,0-17.5,1.9-24.7,5.8c-7.2,3.9-12.9,9.2-17,16.1c-4.1,6.8-6.1,14.6-6.1,23.3 c0,8.7,2,16.5,6.1,23.4c4.1,6.9,9.8,12.3,17,16.1c7.3,3.9,15.5,5.8,24.7,5.8c8.6,0,16.2-1.8,22.8-5.4c6.6-3.6,11.6-8.7,15-15.3 L289.8,94c-2.5,4.1-5.7,7.1-9.5,9.2c-3.8,2-8,3.1-12.5,3.1c-7.8,0-14.3-2.5-19.3-7.5c-5-5-7.5-11.7-7.5-20.1 c0-8.4,2.5-15.1,7.6-20.1C253.7,53.5,260.1,51,267.8,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.3,39.1c-6.8-3.8-14.5-5.7-23.1-5.7c-8.7,0-16.6,1.9-23.5,5.8c-7,3.9-12.4,9.2-16.3,16.1 c-3.9,6.9-5.9,14.7-5.9,23.3c0,8.7,2,16.5,6,23.4c4,6.9,9.7,12.3,17.1,16.1c7.4,3.9,15.9,5.8,25.7,5.8c7.6,0,14.5-1.2,20.5-3.6 c6.1-2.4,11.1-6,15.1-10.8l-11.1-12.7c-6.3,6.4-14.3,9.6-24,9.6c-7.6,0-14-1.9-19.1-5.7c-5.1-3.8-8.3-9-9.5-15.5h69.4 c0.2-2.6,0.3-4.7,0.3-6.1c0-9-1.9-17-5.7-23.9C393.4,48.3,388.1,43,381.3,39.1z M333,71.5c1-6.5,3.8-11.7,8.4-15.6 c4.6-3.9,10.2-5.9,16.8-5.9c6.7,0,12.4,2,16.9,6c4.5,4,7.2,9.2,8.1,15.6H333z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.3,
    className: "st0",
    width: 20.7,
    height: 122.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.5,47.3V34.4h-19.7v88.4h20.7V79.9c0-8.8,2.3-15.6,6.8-20.3c4.5-4.7,10.8-7,18.9-7c1.4,0,3,0.2,4.8,0.5 V33.4C570,33.4,559.5,38.1,553.5,47.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.8,
    y: 34.4,
    className: "st0",
    width: 20.7,
    height: 88.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.8,55.3c-4-6.8-9.6-12.2-16.8-16.1c-7.2-3.9-15.3-5.8-24.3-5.8c-8.9,0-17,1.9-24.2,5.8 c-7.2,3.9-12.8,9.2-16.8,16.1c-4,6.8-6,14.6-6,23.3c0,8.7,2,16.5,6,23.4c4,6.9,9.6,12.3,16.8,16.1c7.2,3.9,15.2,5.8,24.2,5.8 c9,0,17.2-1.9,24.3-5.8c7.2-3.9,12.8-9.2,16.8-16.1c4-6.9,6-14.7,6-23.4C718.9,69.9,716.9,62.1,712.8,55.3z M690.6,98.7 c-5,5.1-11.3,7.6-18.9,7.6c-7.6,0-13.9-2.5-18.8-7.6c-4.9-5.1-7.4-11.8-7.4-20c0-8.3,2.5-15,7.4-20c4.9-5.1,11.2-7.6,18.8-7.6 c7.6,0,13.9,2.5,18.9,7.6c5,5.1,7.4,11.8,7.4,20C698,86.9,695.5,93.6,690.6,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.1,90.8c-3.5,2.5-7.2,4.6-10.9,6.5l11,25.6h22.5l-16.5-36.6C107.2,87.8,105.2,89.3,103.1,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,95c16.4,0,33.7-5.4,48.6-15.7c18.9-13.1,31.7-32.4,35.2-52.9l-20.2-3.4c-2.1,12.5-9.2,24.5-19.7,34 L73.3,7H52.1L0,122.8h22.2l10-23.5l-9.7-10.9c0,0,0,0,0,0C31.5,92.8,41.5,95,51.9,95z M45,69.4l17.5-41l14.8,34.3l2.2,5.1 c-12,5.9-24.9,7.9-36.4,5.9L45,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.5,42.8c-6.4-5.8-15.4-8.8-27.1-9.3h-26.7V51h26.7V51c4.7,0.6,8.5,2.2,11.2,4.6c3.7,3.3,5.5,8.1,5.5,14.2 v1.3h-22.8c-12.7,0-22,2.4-27.9,7.2c-5.9,4.8-8.9,11.2-8.9,19.1c0,5.1,1.4,9.6,4.1,13.7c2.7,4,6.5,7.2,11.5,9.4 c5,2.3,10.8,3.4,17.4,3.4c6.6,0,12.3-1,17-3.1c4.7-2,8.3-5,10.8-8.9v10.8h19.5V71C522.8,58.4,519.4,49,512.5,42.8z M502.2,95.2 c-1.7,4.4-4.5,7.8-8.5,10.2c-4,2.4-8.6,3.6-13.8,3.6c-5.3,0-9.4-1.1-12.4-3.3c-3-2.2-4.5-5.2-4.5-8.9c0-7.8,6-11.8,17.9-11.8h21.4 V95.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6e686c855015b18b75f4b469fb58d13c.svg";
export { ForwardRef as ReactComponent };